/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsissueprice2Inputs */

const en_ticketsissueprice2 = /** @type {(inputs: Ticketsissueprice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the price in euros, for example 12.50.`)
};

const de_ticketsissueprice2 = /** @type {(inputs: Ticketsissueprice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib den Preis in Euro an, zum Beispiel 12,50.`)
};

/**
* | output |
* | --- |
* | "Enter the price in euros, for example 12.50." |
*
* @param {Ticketsissueprice2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsissueprice2 = /** @type {((inputs?: Ticketsissueprice2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsissueprice2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsissueprice2(inputs)
	return de_ticketsissueprice2(inputs)
});
export { ticketsissueprice2 as "ticketsIssuePrice" }